export default __webpack_public_path__ + "static/media/tgv-site-bottom.4c8a6133.png";